import React from 'react';
import PropTypes from 'prop-types';

import { trackExternalLinkEvent } from '../eventService';

const withHttpProtocol = (url) => (
  /^https?:\/\//.test(url) ? url : `http://${url}`
);

const ExternalLink = ({
  ariaLabel,
  children,
  className,
  href,
  onClick,
}) => (
  <a
    href={withHttpProtocol(href)}
    aria-label={ariaLabel}
    rel="noopener"
    target="_blank"
    className={className}
    onClick={onClick}
  >
    {children}
  </a>
);

ExternalLink.defaultProps = {
  ariaLabel: null,
  className: null,
  onClick: trackExternalLinkEvent,
};

ExternalLink.propTypes = {
  ariaLabel: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  href: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default ExternalLink;
